import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../Api";

export function useActivateAccount() {
    const { code } = useParams();
    const [message, setMessage] = useState("Bezig met activeren...");
    const navigate = useNavigate();

    useEffect(() => {
        const activate = async () => {
            try {
                await api.post("/users/activate", { code });
                setMessage("Account succesvol geactiveerd! Je wordt doorgestuurd naar de loginpagina.");
                setTimeout(() => navigate("/login"), 3000);
            } catch (err) {
                setMessage("Activatie mislukt. Deze link is mogelijk verlopen of ongeldig.");
            }
        };
        activate();
    }, [code, navigate]);

    return { message };
}

